import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import merge from 'lodash/merge';
import { useCallback, useState } from 'react';
import { getHashItemKey } from '@/utils/objects';
import { encodeSelections } from '@/utils/widget/parseSelections';
import selectionSettings from '@/components/Editor/selectionSettings';
const PREFIX = 'common: components: Editor: hooks: useSelectionsEditing:';
export default function useSelectionsEditing() {
  const {
    0: activeSelectionsType,
    1: setActiveSelectionsType
  } = useState('values');
  const {
    0: activeSelections,
    1: setActiveSelections
  } = useState('');
  const {
    0: activeLabelsSelections,
    1: setActiveLabelsSelections
  } = useState('');
  const {
    0: activeLegendsSelections,
    1: setActiveLegendsSelections
  } = useState('');
  const {
    0: isEditingSelections,
    1: setIsEditingSelections
  } = useState(false);
  const {
    0: selectionEditIsLabeled,
    1: setSelectionEditIsLabeled
  } = useState(false);
  const {
    0: selectionEditStrategy,
    1: setSelectionEditStrategy
  } = useState(''); // selects default

  const {
    0: selectionControls,
    1: setSelectionControls
  } = useState({}); // Path to provide user updates to

  const {
    0: submissionTarget,
    1: setSubmissionTarget
  } = useState(''); // Setup data selection modal for
  // various targets of of selections

  const onSelectionSetup = useCallback(_ref => {
    let {
      widget,
      section: targetSection,
      question: targetQuestion,
      selectionsType = 'values'
    } = _ref;
    // Use question selection settings
    // if a question is provided
    const targetSettings = targetQuestion ? selectionSettings['Question'] : selectionSettings[targetSection.component];

    if (!targetSettings) {
      throw Error(`${PREFIX} Section type "${targetSection.component}" has no selection configuration`);
    } // Merge the target section's
    // configuration with any overrides
    // provided by the selection settings


    const sectionConfig = merge({}, targetSection.config, (targetSettings === null || targetSettings === void 0 ? void 0 : targetSettings.configOverrides) || {}); // Used to submit updates to
    // their correct destination

    const targetSectionId = targetSection.id || getHashItemKey(widget.sections || {}, targetSection);
    let initialSubmissionTarget = `sections.${targetSectionId}.config`;

    if (targetQuestion) {
      setActiveSelections(encodeSelections(targetQuestion.selections || ''));
      setSelectionEditIsLabeled(typeof targetQuestion.selectionsLabeled === 'boolean' ? targetQuestion.selectionsLabeled : true); // Use custom or fallback to default

      setSelectionEditStrategy(targetQuestion.selectionsStrategy || '');
      const foundQuestion = sectionConfig.questions.find(_ref2 => {
        let {
          id
        } = _ref2;
        return targetQuestion.id === id;
      });
      const questionIndex = sectionConfig.questions.indexOf(foundQuestion);

      if (questionIndex === -1) {
        throw Error(`${PREFIX} onSelectionSetup: Question not found in section configuration`);
      }

      initialSubmissionTarget += `.questions.${questionIndex}`;
    } else if (targetSection) {
      setActiveSelections(encodeSelections(sectionConfig.selections || ''));
      setActiveLabelsSelections(encodeSelections(sectionConfig.labelsSelections || ''));
      setActiveLegendsSelections(encodeSelections(sectionConfig.legendsSelections || ''));
      setSelectionEditIsLabeled(typeof sectionConfig.selectionsLabeled === 'boolean' ? sectionConfig.selectionsLabeled : true); // Use custom or fallback to default

      setSelectionEditStrategy(sectionConfig.selectionsStrategy || '');
    }

    if (selectionsType) {
      setActiveSelectionsType(selectionsType);
    } // Configure the selection modal's
    // user interface controls


    setSelectionControls({
      descriptions: targetSettings.descriptions || {},
      textOverrides: targetSettings.textOverrides || {},
      multiCollectionSelections: targetSettings.multiCollectionSelections || [],
      maxSelections: _objectSpread({
        default: Infinity
      }, targetSettings.maxSelections || {}),
      multiCollectionMaximums: targetSettings.multiCollectionMaximums || {},
      selectionLimits: _objectSpread({
        default: {
          size: Infinity
        }
      }, targetSettings.selectionLimits || {}),
      labelsSelectionsSupported: targetSettings.labelsSelectionsSupported || {},
      legendsSelectionsSupported: targetSettings.legendsSelectionsSupported || {},
      selectionGuides: targetSettings.selectionGuides || {}
    });
    setSubmissionTarget(initialSubmissionTarget);
    setIsEditingSelections(true);
  }, []); // Reset the selections setup

  const onSelectionTeardown = useCallback(() => {
    setSubmissionTarget('');
    setActiveSelections('');
    setActiveLabelsSelections('');
    setActiveLegendsSelections('');
    setSelectionEditIsLabeled(false);
    setIsEditingSelections(false);
  }, []); // Provide updates to correct
  // submission target

  const onSubmitSelection = useCallback((submit, updates) => {
    if (!submissionTarget) {
      throw Error(`${PREFIX} missing submission target, submit before teardown`);
    }

    submit(submissionTarget, updates);
  }, [submissionTarget]);
  return {
    activeSelectionsType,
    // initial selection type
    activeSelections,
    // selections user will update
    activeLabelsSelections,
    // labels selections user will update
    activeLegendsSelections,
    // legends selections user will update
    isEditingSelections,
    selectionEditIsLabeled,
    selectionEditStrategy,
    selectionControls,
    onSelectionSetup,
    onSelectionTeardown,
    onSubmitSelection
  };
}